import { Props_SnippetVideo } from './Video.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'
import VideoComponent from '../Shared/SharedVideo/SharedVideo'

const SnippetVideo = (props: Props_SnippetVideo) => {
    const { heading, content, repeatable_link, video } = props
    const classHeadingVisibility = heading.visibility?.value ? '' : 'snippet-video__heading--hidden'
    const classContentAlignment = content.alignment?.value ? `snippet-video--content-alignment-${content.alignment.value}` : '' 
    const classVideoFullscreen = video?.fullscreen?.value ? 'snippet-video--video-fullscreen' : ''
    const classVideoPosition = video?.position?.value ? `snippet-video--video-position-${video.position.value}` : ''

    return (
        <section className={`snippet-video ${classVideoFullscreen} ${classVideoPosition} ${classContentAlignment}`}>
            <div className="snippet-video__container">
                <div className="snippet-video__container-content">
                    <div className={`snippet-video__heading ${classHeadingVisibility}`}>{CompileMarkdown(heading.content.value!)}</div>
                    <div className="snippet-video__content">
                        {content.content?.value && CompileMarkdown(content?.content?.value)}
                    </div>
                    <div className="snippet-video__container-links">
                        {repeatable_link?.map(({ linkHref, linkText, linkStyle, linkTarget }, index) => (
                            <SnippetLink
                                key={`link-${index}`}
                                url={linkHref?.value}
                                className="snippet-video__link"
                                linkStyles={linkStyle?.value}
                                openInNewTab={linkTarget?.value}
                            >
                                {linkText?.value}
                            </SnippetLink>
                        ))}
                    </div>
                </div>

                <VideoComponent
                    snippetClassName="snippet-video"
                    url={video?.url.value ?? ''}
                    thumbnail={video?.thumbnail?.value}
                    thumbnailAlt={video?.alt?.value}
                    audioDescriptionUrl={video?.audioDescriptionUrl?.value}
                />
            </div>
        </section>
    )
}

export default SnippetVideo